import { createFileRoute } from '@tanstack/react-router'

import { CustomerProjectScope } from '@/components/Customer/CustomerProjectScope'
import { requireCustomerProject } from '@/utils/customer-shadow'

export const Route = createFileRoute(
  '/internal/customer-view/$userId/project/$projectId',
)({
  beforeLoad: requireCustomerProject,
  component: CustomerProjectScope,
})
